export default __webpack_public_path__ + "static/mt-aeab19012d58e31efd108176178b0ee1.svg";